import React, {useState} from "react"
import {ActionButton} from "../../util/UI/ActionButton";
import ContactMethodType = space.kenko.proto.ContactMethodType;
import {useAuth0} from "@auth0/auth0-react";
import {EmailOrPhoneLocation, space, VerificationRequest} from "../../provider_api";
import {useVerificationRpc} from "../../util/RpcHooks/VerificationRpc";
import {useProviderProfile} from "../../ProviderProfileProvider";
import {LabeledTextInput} from "../../components/input/LabeledTextInput";

export const Email = () => {

  const verificationRpc = useVerificationRpc();
  const {provider} = useProviderProfile();
  const {user} = useAuth0();

  const [verificationCode, setVerificationCode] = useState<string>('');

  const [email, setEmail] = useState<string>();

  // If they're opting to use a different email than their login email.
  const [notUsingLoginEmail, setNotUsingLoginEmail] = useState(false);

  // If they have an email but want to go back to step 1 and change it.
  const [isEditingEmail, setIsEditingEmail] = useState(false);

  // True if an OTP was sent
  const [sentOtp, setSentOtp] = useState(false);

  
  if (!provider?.contactEmail && user?.email && !notUsingLoginEmail) {
    return <div className={'SurveySection'}>
      Is {user?.email} a good contact email?

      <ActionButton rpcState={verificationRpc.rpcState}
                    onClick={() => verificationRpc.send('set_provider_contact_method', new VerificationRequest({
                      type: ContactMethodType.EMAIL,
                      location: EmailOrPhoneLocation.PROVIDER,
                      value: user?.email,
                    }))}>Yes
      </ActionButton>

      <ActionButton secondary onClick={() => setNotUsingLoginEmail(true)}>
        Choose a different email
      </ActionButton>

      {verificationRpc.rpcState.state == 'error' &&
          <div className={'ErrorText'}>{verificationRpc.rpcState.message}</div>}

    </div>
  }

  // Manually enter a different email address 
  if (!provider?.contactEmail || isEditingEmail) {

    return <div className={'SurveySection'}>
      <h3>What is a good email for contacting you?</h3>

      <LabeledTextInput inputType={'email'}
                        label={'Contact email'}
                        value={email}
                        onChange={setEmail}/>

      <ActionButton rpcState={verificationRpc.rpcState}
                    onClick={() => verificationRpc.send('set_provider_contact_method', new VerificationRequest({
                      type: ContactMethodType.EMAIL,
                      location: EmailOrPhoneLocation.PROVIDER,
                      value: email,
                    }), () => setIsEditingEmail(false))}>Continue</ActionButton>

      {verificationRpc.rpcState.state == 'error' &&
          <div className={'ErrorText'}>{verificationRpc.rpcState.message}</div>}

    </div>
  }

  if (!sentOtp) {
    return <div className={'SurveySection'}>
      <h3>Please confirm your email address.</h3>
      <div>We'll send a verification code to: {provider?.contactEmail}</div>

      <ActionButton rpcState={verificationRpc.rpcState}
                    onClick={() => verificationRpc.send('send_verification', new VerificationRequest({
                      type: ContactMethodType.EMAIL,
                      location: EmailOrPhoneLocation.PROVIDER,
                      value: provider?.contactEmail,
                    }), () => setSentOtp(true))}>Send</ActionButton>

      <ActionButton secondary smaller onClick={() => setIsEditingEmail(true)}>
        Use a different email address
      </ActionButton>

      {verificationRpc.rpcState.state == 'error' &&
          <div className={'ErrorText'}>{verificationRpc.rpcState.message}</div>}

    </div>
  }


  return <div className={'SurveySection'}>
    <h3>Please enter the verification code you received.</h3>

    <LabeledTextInput
        label={'Verification Code'}
        inputType={'text'}
        value={verificationCode}
        onChange={v => setVerificationCode(v ?? '')}/>

    <ActionButton rpcState={verificationRpc.rpcState}
                  onClick={() => verificationRpc.send('check_verification_code', new VerificationRequest({
                    type: ContactMethodType.EMAIL,
                    location: EmailOrPhoneLocation.PROVIDER,
                    value: verificationCode,
                  }))}>Verify Email</ActionButton>

    <ActionButton secondary smaller onClick={() => setSentOtp(false)}>Go back</ActionButton>

    {verificationRpc.rpcState.state == 'error' && <div className={'ErrorText'}>{verificationRpc.rpcState.message}</div>}
  </div>
}